export default __webpack_public_path__ + "static/media/13.ebccd370.png";